import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers['Content-Type'] = 'application/json'

Vue.use(VueAxios, axios)